var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
import { IDENTIFIERS } from '../../../types/Identifiers';
import { TAG_TYPES } from '../../../types/TagTypes';
import PROPS from '../../../types/Props';
export var GROUPS_POST = {
    tags: [
        {
            type: TAG_TYPES.TITLE,
            children: '{{group.post.content.60}} | {{group.name}}',
        },
        {
            type: TAG_TYPES.META,
            props: (_a = {},
                _a[PROPS.NAME] = 'description',
                _a[PROPS.CONTENT] = "{{group.post.content.200}}",
                _a),
        },
        {
            type: TAG_TYPES.META,
            props: (_b = {},
                _b[PROPS.NAME] = 'robots',
                _b[PROPS.CONTENT] = 'index',
                _b),
        },
        {
            type: TAG_TYPES.META,
            props: (_c = {},
                _c[PROPS.PROPERTY] = 'og:title',
                _c[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}",
                _c),
        },
        {
            type: TAG_TYPES.META,
            props: (_d = {},
                _d[PROPS.PROPERTY] = 'og:description',
                _d[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}",
                _d),
        },
        {
            type: TAG_TYPES.META,
            props: (_e = {},
                _e[PROPS.PROPERTY] = 'og:image',
                _e[PROPS.CONTENT] = '{{post.coverImage.url}}',
                _e),
        },
        {
            type: TAG_TYPES.META,
            props: (_f = {},
                _f[PROPS.PROPERTY] = 'og:image:width',
                _f[PROPS.CONTENT] = '{{post.coverImage.width}}',
                _f),
        },
        {
            type: TAG_TYPES.META,
            props: (_g = {},
                _g[PROPS.PROPERTY] = 'og:image:height',
                _g[PROPS.CONTENT] = '{{post.coverImage.height}}',
                _g),
        },
        {
            type: TAG_TYPES.META,
            props: (_h = {},
                _h[PROPS.PROPERTY] = 'og:site_name',
                _h[PROPS.CONTENT] = '{{site.name}}',
                _h),
        },
        {
            type: TAG_TYPES.META,
            props: (_j = {},
                _j[PROPS.PROPERTY] = 'og:url',
                _j[PROPS.CONTENT] = '{{group.post.url}}',
                _j),
        },
        {
            type: TAG_TYPES.META,
            props: (_k = {},
                _k[PROPS.PROPERTY] = 'og:type',
                _k[PROPS.CONTENT] = 'website',
                _k),
        },
        {
            type: TAG_TYPES.LINK,
            props: (_l = {},
                _l[PROPS.REL] = 'canonical',
                _l[PROPS.HREF] = '{{group.post.url}}',
                _l),
        },
        {
            type: TAG_TYPES.META,
            props: (_m = {},
                _m[PROPS.PROPERTY] = 'article:author',
                _m[PROPS.CONTENT] = '{{groups.post.author}}',
                _m),
        },
        {
            type: TAG_TYPES.META,
            props: (_o = {},
                _o[PROPS.PROPERTY] = 'article:published_time',
                _o[PROPS.CONTENT] = '{{groups.post.publish.date}}',
                _o),
        },
        {
            type: TAG_TYPES.META,
            props: (_p = {},
                _p[PROPS.PROPERTY] = 'article:modified_time',
                _p[PROPS.CONTENT] = '{{groups.post.modified.date}}',
                _p),
        },
        {
            type: TAG_TYPES.SCRIPT,
            props: (_q = {},
                _q[PROPS.TYPE] = 'application/ld+json',
                _q),
            disabled: '{{groups.post.disable-schema}}',
            children: "{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"DiscussionForumPosting\",\n  \"author\": {\n    \"@type\": \"Person\",\n    \"name\": \"{{groups.post.author}}\",\n    \"image\": {\n      \"@type\": \"ImageObject\",\n      \"height\": \"{{post.owner.image.height}}\",\n      \"width\": \"{{post.owner.image.width}}\",\n      \"url\": \"{{post.owner.image.url}}\"\n    }\n  },\n  \"articleSection\": \"Group name\",\n  \"dateModified\": \"2019-12-15\",\n  \"datePublished\": \"2019-12-15\",\n  \"headline\": \"{{post.title}}\",\n  \"mainEntityOfPage\": {\n    \"@id\": \"{{post.url}}\",\n    \"@type\": \"itemPage\"\n  },\n  \"description\": \"{{post.description}}\",\n  \"url\": \"{{post.url}}\",\n  \"commentCount\": \"{{post.comments.count}}\",\n  \"interactionStatistic\": {\n    \"interactionType\": \"{http://schema.org/LikeAction}\",\n    \"userInteractionCount\": \"{{post.interaction.like.count}}\"\n  },\n  \"image\": {\n    \"@type\": \"ImageObject\",\n    \"height\": \"{{post.coverImage.height}}\",\n    \"width\": \"{{post.coverImage.width}}\",\n    \"url\": \"{{post.coverImage.url}}\"\n  },\n  \"publisher\": {\n    \"@type\": \"Organization\",\n    \"@id\": \"{{publisher.id}}\",\n    \"name\": \"{{group.name}}\",\n    \"logo\": {\n      \"@type\": \"ImageObject\",\n      \"url\": \"{{publisher.logo.url}}\"\n    }\n  }\n}",
        },
    ],
};
